/** @module csi/widget/ActionsComboButton */
define([
	"dojo/_base/declare",
	"dojo/_base/event",
	"dojo/_base/lang",
	"dojo/on",
	"dojo/keys",
	"dojo/topic",
	"dijit/form/ComboButton",
	"dijit/Menu",
	"dijit/MenuItem",
	"underscore",
	"csi/html",
	"csi/locale",
	"csi/widget/MenuLabel",
	"csi/widget/Tooltip",
], function(declare, event, lang, on, keys, topic, ComboButton, Menu, MenuItem, _, html, locale, MenuLabel, Tooltip) {

	return declare(ComboButton, {
		/** @property {Action[]} actions - actions to present in control drop down */
		actions: [],

		/** @property {boolean} displayOnly - set to true, only for display purpose, not clickable */
		displayOnly: false,

		/** @property {(key: number, bShift: boolean) => void} displayOnly - extension point for passing through widget with tab/enter */
		onNext: null,

		/** @property {Action[]} placeholderActions - section actions to present in control drop down */
		placeholderActions: [],

		/** @property {boolean} bCreateButton - if true, this is button "Create" for placements, if false - normal split button 
		 * "CreateButton" is special design of "New Actions" button, used in BOM/Placements*/
		//bCreateButton: false,

		/** @property {boolean} bDropDownMenu - if true, button works as drop menu, no action on button click, just open the menu */
		//bDropDownMenu: false,

		_tooltip: null,

		destroy() {
			this.inherited(arguments);

			if (this._tooltip) {
				this._tooltip.destroy();
			}
		},

		/** Extension point for triggering action
		 * @param {Action} a
		 */
		onAction(a) { },

		/**
		 * Create and Open drop down, make it focused
		 */
		openAndFocusDropDown() {
			this.loadAndOpenDropDown();
			this.dropDown.focus();
		},

		postCreate() {
			const {actions, buttonNode, titleNode, _buttonNode} = this;
			const areActionsPresent = !!actions.length;
			const tooltipMasterCss = (areActionsPresent) ? "csi-dijit-to-mui-tooltip" : "csi-dijit-to-actions-combobutton";

			if (areActionsPresent) {
				// only want one button to have tabIndex to ease keyboard input
				titleNode.tabIndex = -1;
				this._setTabIndexAttr = ["focusNode"];
			} else {
				html.setVisible(_buttonNode, false);
			}

			this.own(
				topic.subscribe("/csi/tooltip/show", (tooltip, aroundNode) => {
					if (aroundNode === buttonNode) {
						Tooltip.setMasterCss(tooltipMasterCss);
					}
				})
			);

			this.inherited(arguments);
		},

		/**
		 * Return actions context for view
		 * @return {Context}
		 */
		getActionsContext() {
			var w = this.widget;
			var qrRoot = w && w.getQueryResult();
			return qrRoot && qrRoot.getChildContext();
		},

		/**
		 * Create drop down for normal split Combo Button
		 */
		loadSplitButtonDropDown() {
			var self = this;
			var ctx = this.getActionsContext();

			if (this.displayOnly) {
				this.actions.forEach(function(a) {
					self.dropDown.addChild(new MenuLabel({
						baseClass: "dijitMenuLabel csi-rounded-combo-pill-info",
						label: locale.resource(a.getName())
					}));
				});
			} else {
				this.actions.forEach(function(a) {
					self.dropDown.addChild(new MenuItem({
						label: locale.resource(a.getName()),
						disabled: ctx && !a.hasAccess(ctx),
						onClick: lang.hitch(self, self.onAction, a)
					}));
				});
			}

		},

		/**
		 * Create drop down for Part Material "Create" Combo Button
		 */
		loadCreateButtonDropDown() {
			var self = this;
			this.dropDown.addChild(new MenuLabel({
				label: this.newActionsButtonGroups[0]
			}));
			this.loadSplitButtonDropDown();
			if (this.placeholderActions.length) {
				this.dropDown.addChild(new MenuLabel({
					label: this.newActionsButtonGroups[1]
				}));
				var ctx = this.getActionsContext();
				this.placeholderActions.forEach(function(a) {
					self.dropDown.addChild(new MenuItem({
						label: locale.resource(a.getName()),
						disabled: ctx && !a.hasAccess(ctx),
						onClick: lang.hitch(self, self.onAction, a)
					}));
				});
			}
		},

		loadAndOpenDropDown() {
			if (!this.dropDown) {
				this.dropDown = new Menu();
				if (this.bCreateButton) {
					this.loadCreateButtonDropDown();
				} else {
					this.loadSplitButtonDropDown();
				}
			}
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Handle create button that has no main action and clicking it should just open the drop down
		 */
		_onClick(e) {
			if (this.bCreateButton && !this.disabled) {
				this.openAndFocusDropDown();
				event.stop(e);
			} else {
				this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * Handle keyboard events on main action button
		 */
		_onKey(e) {
			const {buttonNode, onNext} = this;
			const {keyCode, shiftKey} = e;

			if (keyCode == keys.SPACE) {
				// fire click event on main button
				on.emit(buttonNode, "click", {bubbles: true});
				event.stop(e);
			} else if (keyCode == keys.TAB && onNext) {
				// for inline button, let view navigate to next cell
				onNext(keyCode, shiftKey);
				event.stop(e);
			} else {
				this.inherited(arguments);
			}
		},

		_setTitleAttr(title) {
			this._set("title", title);

			this._tooltip = this._tooltip || new Tooltip({
				connectId: this.buttonNode,
				hideDelay: 0,
				position: ["above"],
				showDelay: 0,
			});
			this._tooltip.label = _.escape(title);
		}
	});
});